var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',[(!_vm.isHidden)?_c('v-btn',{attrs:{"text":""},on:{"click":_vm.hide}},[_vm._v("Hide")]):_vm._e(),(_vm.isHidden)?_c('v-btn',{attrs:{"text":""},on:{"click":_vm.show}},[_vm._v("Show")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }